import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitContact = (data) => api.post("/contact", data);
export const submitBooking = (data) => api.post("/bookings", data);
export const fetchInsights = () => api.get("/insights").then((r) => r.data);
export const fetchCaseStudies = () => api.get("/case-studies").then((r) => r.data);
